import React, { useEffect, useState } from "react";

// Antd
import {
  PlusOutlined,
  WhatsAppOutlined,
  HeartFilled,
  SearchOutlined,
  FilterOutlined,
  AppstoreOutlined,
  UserOutlined,
} from "@ant-design/icons";
import {
  Input,
  Select,
  Spin,
  Tooltip,
  Modal,
  message,
  Button,
  Empty,
  Badge,
  Segmented,
} from "antd";
import { Link } from "react-router-dom";

// API
import {
  addCourseToWishList,
  getAllCoursesByRole,
  getUserById,
  getUsersCourses,
  removeCourseFromWishList,
  getWishListCourcesByUser,
  editCourse,
  getAllUsers,
} from "../../../Constants/Api/functions/function";

// Redux
import { useDispatch, useSelector } from "react-redux";
import { setAllCources } from "../../../Reducers/allCourcesReducer";

// Styles
import "./style.scss";

import AddCource from "./AddCource";
import { DEFAULT_USER_PROFILE_IMAGE } from "../../../Constants/Api/azure/azure";
import { setUsersCources } from "../../../Reducers/usersCourcesReducer";
import { setUserProfile } from "../../../Reducers/userProfileReducer";

const Cources = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isAddCourseOpen, setIsAddCourseOpen] = useState(false);
  const [radioValue, setRadioValue] = useState(1);
  const [searchValue, setSearchValue] = useState('');
  const [activeTag, setActiveTag] = useState('All');
  const userProfile = useSelector((state) => state.userProfile.userProfile);
  const allCources = useSelector((state) => state.allCources.allCources);

  const filteredCources = React.useMemo(() => {
    if (!allCources) return [];
    if (userProfile?.role === "coordinator") {
      return allCources.filter(
        (c) =>
          c.coordinatorId &&
          String(c.coordinatorId) === String(userProfile.id)
      );
    }
    return allCources;
  }, [allCources, userProfile]);

  const [userCources, setUserCources] = useState();
  const [data, setData] = useState();
  const [coursesData, setCoursesData] = useState();
  const [wishlistCourses, setWishlistCourses] = useState([]);
  const [activeTab, setActiveTab] = useState('courses');
  const dispatch = useDispatch();

  const displayedItems = React.useMemo(() => {
    if (!coursesData) return [];
    return coursesData.filter(item => {
      if (activeTab === 'books') {
        return item.type === 'book';
      } else {
        return item.type !== 'book';
      }
    });
  }, [coursesData, activeTab]);

  const [showAssignModal, setShowAssignModal] = useState(false);
  const [selectedCourseId, setSelectedCourseId] = useState(null);
  const [selectedCoordinatorId, setSelectedCoordinatorId] = useState(undefined);
  const [coordinators, setCoordinators] = useState([]);
  const [instructors, setInstructors] = useState([]);
  const [isAssigning, setIsAssigning] = useState(false);

  useEffect(() => {
    const fetchUsers = async () => {
      if (
        userProfile?.role === "superadmin" ||
        userProfile?.role === "admin"
      ) {
        try {
          const users = await getAllUsers();
          if (users) {
            const filteredCoordinators = users.filter(
              (u) => u.role === "coordinator"
            );
            setCoordinators(filteredCoordinators);
            const filteredInstructors = users.filter(
              (u) => u.role === "instructor"
            );
            setInstructors(filteredInstructors);
          }
        } catch (error) {
          console.error("Failed fetching users:", error);
        }
      }
    };
    fetchUsers();
  }, [userProfile]);

  const handleAssignCoordinator = async () => {
    setIsAssigning(true);
    try {
      const selectedCoord = coordinators.find(
        (c) => c.id === selectedCoordinatorId
      );
      const response = await editCourse({
        id: selectedCourseId,
        coordinatorId: selectedCoordinatorId || null,
        coordinatorName: selectedCoord ? selectedCoord.name : null,
        coordinatorWhatsApp: selectedCoord
          ? selectedCoord.contactNumber
          : null,
      });
      if (response && response.status === 200) {
        message.success("Coordinator assigned successfully");
        setShowAssignModal(false);
        await hadleGetCources();
      } else {
        message.error("Failed to assign coordinator");
      }
    } catch (error) {
      console.error("handleAssignCoordinator error:", error);
      message.error("Failed to assign coordinator");
    } finally {
      setIsAssigning(false);
    }
  };

  useEffect(() => {
    if (data && data.length > 0) {
      const sortedData = [...data].sort((a, b) => {
        return a?.orderNumber - b?.orderNumber;
      });
      setCoursesData(
        sortedData.map((item) => {
          return {
            id: item?.id,
            title: item?.name,
            description: item?.description,
            isPublished: item?.isPublished,
            thumbnail: item?.coverImage,
            price: item?.price,
            authorName: item?.createdBy?.name,
            authorImage: item?.createdBy?.profileImage,
            orderNumber: item?.orderNumber,
            whatsappGroupLink: item?.whatsappGroupLink,
            tags: item?.tags,
            status: item?.status,
            instructorId: item?.instructorId,
            instructorName: item?.instructorName,
            coordinatorId: item?.coordinatorId,
            coordinatorName: item?.coordinatorName,
            type: item?.type || 'course',
            pdfUrl: item?.pdfUrl || null,
          };
        })
      );
    } else if (data && data.length === 0) {
      setCoursesData([]);
    }
  }, [data, userCources]);

  // Fetch wishlist courses
  useEffect(() => {
    if (
      userProfile?.id &&
      userProfile?.role !== "superadmin" &&
      userProfile?.role !== "admin"
    ) {
      handleGetWishlistCourses();
    }
  }, [userProfile?.id]);

  useEffect(() => {
    if (
      userProfile?.role !== "superadmin" &&
      userProfile?.role !== "admin"
    ) {
      handleGetUserCources();
    }
  }, []);

  useEffect(() => {
    if (userProfile) {
      hadleGetCources();
    }
  }, [userProfile]);

  const handleGetWishlistCourses = async () => {
    try {
      const response = await getWishListCourcesByUser(userProfile.id);
      if (response && Array.isArray(response)) {
        setWishlistCourses(response);
      }
    } catch (error) {
      console.error("handleGetWishlistCourses error:", error);
    }
  };

  useEffect(() => {
    if (
      filteredCources &&
      filteredCources.length > 0 &&
      userProfile &&
      radioValue === 1
    ) {
      const ongoingCourses = filteredCources?.filter((course) => {
        return course?.status !== "completed";
      });
      setData(ongoingCourses);
    }
  }, [filteredCources, radioValue, userProfile]);

  const hadleGetCources = async () => {
    setIsLoading(true);
    try {
      if (userProfile) {
        let response = await getAllCoursesByRole(
          userProfile.role,
          userProfile.id
        );
        if (response && Array.isArray(response)) {
          if (userProfile.role === "superadmin") {
            const ongoingCourses = response.filter((course) => {
              return course?.status !== "completed";
            });
            setData([...ongoingCourses]);
          } else {
            const ongoingCourses = response.filter((course) => {
              return course?.status !== "completed";
            });
            setData([...ongoingCourses]);
          }
          dispatch(setAllCources([...response]));
        }
      }
    } catch (error) {
      console.error("hadleGetCources error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleGetUserCources = async () => {
    setIsLoading(true);
    try {
      const userCources = await getUsersCourses(userProfile?.id);
      setUserCources(userCources);
      dispatch(setUsersCources(userCources));
    } catch (error) {
      console.error("handleGetUserCources", error);
    }
    setIsLoading(false);
  };

  const onChangeRadio = (value) => {
    let numValue = value;
    setRadioValue(numValue);
    if (numValue === 1) {
      const ongoingCourses = filteredCources?.filter((course) => {
        return course?.status !== "completed";
      });
      setData(ongoingCourses);
    } else if (numValue === 3) {
      const filteredData = filteredCources?.filter((item) => {
        const price =
          typeof item?.price === "string"
            ? parseFloat(item.price)
            : item?.price || 0;
        return price === 0;
      });
      setData(filteredData);
    } else if (numValue === 4) {
      const ongoingCourses = filteredCources?.filter((course) => {
        return course?.status === "completed";
      });
      setData(ongoingCourses);
    } else {
      const filteredData = filteredCources?.filter((item) => {
        return userCources?.find((course) => course?.id === item?.id);
      });
      setData(filteredData);
    }
  };

  const filterBytags = (value) => {
    setActiveTag(value);
    if (value === "All") {
      setData(filteredCources);
    } else {
      const filteredData = data?.filter((item) => {
        const tagsArray = item?.tags?.split(",");
        return tagsArray?.find((tag) => tag === value);
      });
      setData(filteredData);
    }
  };

  const handleSearch = (value) => {
    setSearchValue(value);
    if (value) {
      const filteredData = filteredCources?.filter((item) => {
        return item?.name?.toLowerCase().includes(value.toLowerCase());
      });
      setData(filteredData);
    } else {
      // Reapply current tab filter
      onChangeRadio(radioValue);
    }
  };

  const hnadlegetUserById = async (user) => {
    try {
      if (!user || !user.id) {
        return;
      }
      const response = await getUserById(user.id);
      if (response && response.id) {
        dispatch(setUserProfile(response));
        localStorage.setItem(
          "digital-academy-user",
          JSON.stringify(response)
        );
      }
    } catch (error) {
      console.log("handlegetUserById -> error", error);
    }
  };

  const getTagLabel = (tag) => {
    const tagMap = {
      VideoTutorials: "Video Tutorials",
      Exams: "Exams",
      TrainingAndCourses: "Training & Courses",
      News: "News",
      Seminar: "Seminar",
      eBook: "eBook",
    };
    return tagMap[tag] || tag;
  };

  const getTagColor = (tag) => {
    const colorMap = {
      VideoTutorials: "#6366f1",
      Exams: "#f59e0b",
      TrainingAndCourses: "#10b981",
      News: "#3b82f6",
      Seminar: "#8b5cf6",
      eBook: "#ec4899",
    };
    return colorMap[tag] || "#6366f1";
  };

  const renderTags = (tags) => {
    if (!tags) return null;
    return tags.split(",").map((tag, index) => (
      <span
        key={index}
        className="cs-tag"
        style={{ "--tag-color": getTagColor(tag) }}
      >
        {getTagLabel(tag)}
      </span>
    ));
  };

  const isCourseInWishList = (courseId) => {
    return wishlistCourses?.some(
      (course) => course.id === courseId || course.courseid === courseId
    );
  };

  const isCourseBought = (courseId) => {
    return userCources?.find((course) => course?.id === courseId);
  };

  const handleAddOrRemoveFromWishList = async (courseId) => {
    setIsLoading(true);
    try {
      const isInWishList = isCourseInWishList(courseId);
      if (isInWishList) {
        const res = await removeCourseFromWishList(
          userProfile.id,
          courseId
        );
        if (res) {
          await hnadlegetUserById(userProfile);
          await hadleGetCources();
          await handleGetWishlistCourses();
        }
      } else {
        const res = await addCourseToWishList(userProfile.id, courseId);
        if (res) {
          await hnadlegetUserById(userProfile);
          await hadleGetCources();
          await handleGetWishlistCourses();
        }
      }
    } catch (error) {
      console.log(error);
    }
    setIsLoading(false);
  };

  const isStudent = userProfile?.role === "student";
  const isAdmin =
    userProfile?.role === "superadmin" || userProfile?.role === "admin";
  const isCoordinator = userProfile?.role === "coordinator";
  const isInstructor = userProfile?.role === "instructor";

  // Build Segmented options
  const segmentOptions = [
    { label: activeTab === 'books' ? "All Books" : "All Courses", value: 1 },
    { label: activeTab === 'books' ? "My Books" : "My Courses", value: 2 },
    { label: "Free", value: 3 },
  ];
  if (isAdmin) {
    segmentOptions.push({ label: "Completed", value: 4 });
  }

  return (
    <div className="courses-page">
      {/* ─── Header ─────────────────────────────────────────── */}
      <div className="cs-header">
        <div className="cs-header-left">
          <div className="cs-header-icon">
            <AppstoreOutlined />
          </div>
          <div>
            <h1 className="cs-title">{activeTab === 'books' ? 'Books' : 'Courses'}</h1>
            <p className="cs-subtitle">
              {displayedItems?.length || 0} {activeTab === 'books' ? 'book' : 'course'}
              {displayedItems?.length !== 1 ? "s" : ""} found
            </p>
          </div>
        </div>
        <div className="cs-header-right">
          {isAdmin && (
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={() => setIsAddCourseOpen(true)}
              className="cs-add-btn"
              size="large"
            >
              {activeTab === 'books' ? 'Add Book' : 'Add Course'}
            </Button>
          )}
        </div>
      </div>

      {/* ─── Types Tabs ─── */}
      <div className="cs-types-tabs-container">
        <button
          className={`cs-type-tab ${activeTab === 'courses' ? 'active' : ''}`}
          onClick={() => setActiveTab('courses')}
        >
          🎓 Courses
        </button>
        <button
          className={`cs-type-tab ${activeTab === 'books' ? 'active' : ''}`}
          onClick={() => setActiveTab('books')}
        >
          📖 Books
        </button>
      </div>

      {/* ─── Toolbar ────────────────────────────────────────── */}
      <div className="cs-toolbar">
        <div className="cs-toolbar-left">
          <Segmented
            options={segmentOptions}
            value={radioValue}
            onChange={onChangeRadio}
            className="cs-segment"
          />
        </div>
        <div className="cs-toolbar-right">
          <Input
            prefix={<SearchOutlined style={{ color: "#9ca3af" }} />}
            placeholder={activeTab === 'books' ? "Search books..." : "Search courses..."}
            allowClear
            value={searchValue}
            onChange={(e) => handleSearch(e.target.value)}
            className="cs-search-input"
            size="large"
          />
          <Select
            placeholder="Category"
            suffixIcon={<FilterOutlined />}
            value={activeTag}
            onChange={(value) => filterBytags(value)}
            className="cs-filter-select"
            size="large"
          >
            <Select.Option value="All">All Categories</Select.Option>
            <Select.Option value="VideoTutorials">
              Video Tutorials
            </Select.Option>
            <Select.Option value="Exams">Exams</Select.Option>
            <Select.Option value="TrainingAndCourses">
              Training & Courses
            </Select.Option>
            <Select.Option value="News">News</Select.Option>
            <Select.Option value="Seminar">Seminar</Select.Option>
          </Select>
        </div>
      </div>

      {/* ─── Grid ───────────────────────────────────────────── */}
      <Spin spinning={isLoading} tip={activeTab === 'books' ? "Loading books..." : "Loading courses..."} size="large">
        {displayedItems?.length === 0 && !isLoading ? (
          <div className="cs-empty-state">
            <Empty
              description={
                <span className="cs-empty-text">
                  {searchValue
                    ? `No ${activeTab === 'books' ? 'books' : 'courses'} match your search`
                    : `No ${activeTab === 'books' ? 'books' : 'courses'} found`}
                </span>
              }
            />
          </div>
        ) : (
          <div className="cs-grid">
            {displayedItems.map((item, index) => (
              <div
                className={`cs-card ${item.type === 'book' ? 'book-card' : ''}`}
                key={item.id}
                style={{ animationDelay: `${index * 0.04}s` }}
              >
                {/* Image */}
                <Link
                  to={`/dashboard/cources/${item.id}`}
                  className="cs-card-link"
                >
                  <div className={`cs-card-image ${item.type === 'book' ? 'book-cover-style' : ''}`}>
                    {item.type === 'book' ? (
                      <div className="book-cover-wrap">
                        <div className="book-spine"></div>
                        <img
                          src={
                            item?.thumbnail
                              ? item?.thumbnail
                              : require("./1695793881259.jpeg")
                          }
                          alt={item?.title}
                        />
                      </div>
                    ) : (
                      <img
                        src={
                          item?.thumbnail
                            ? item?.thumbnail
                            : require("./1695793881259.jpeg")
                        }
                        alt={item?.title}
                      />
                    )}

                    {/* Overlays */}
                    <div className="cs-image-overlays">
                      {/* Status badge */}
                      {isStudent ? (
                        <Badge
                          status={
                            item?.status === "completed"
                              ? "success"
                              : "processing"
                          }
                          text={
                            <span className="cs-overlay-text">
                              {item?.status === "completed"
                                ? "Completed"
                                : "Ongoing"}
                            </span>
                          }
                          className="cs-status-badge"
                        />
                      ) : (
                        <Badge
                          status={
                            item?.isPublished ? "success" : "error"
                          }
                          text={
                            <span className="cs-overlay-text">
                              {item?.isPublished
                                ? "Published"
                                : "Unpublished"}
                            </span>
                          }
                          className="cs-status-badge"
                        />
                      )}
                    </div>

                    {/* Wishlist heart */}
                    {isStudent && !isCourseBought(item?.id) && (
                      <div
                        className={`cs-wishlist-btn ${
                          isCourseInWishList(item.id) ? "active" : ""
                        }`}
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          handleAddOrRemoveFromWishList(item.id);
                        }}
                      >
                        <Tooltip
                          title={
                            isCourseInWishList(item.id)
                              ? "Remove from wishlist"
                              : "Request to follow this Course | මෙම පාඨමාලාව හැදෑරීමට ඉල්ලුම් කිරීමට කැමැත්තෙමි."
                          }
                        >
                          <HeartFilled />
                        </Tooltip>
                      </div>
                    )}

                    {/* Free badge */}
                    {item?.price === 0 && (
                      <span className="cs-free-badge">FREE</span>
                    )}
                  </div>
                </Link>

                {/* Content */}
                <Link
                  to={`/dashboard/cources/${item.id}`}
                  className="cs-card-link"
                >
                  <div className="cs-card-content">
                    {/* Tags */}
                    <div className="cs-tags-row">
                      {renderTags(item?.tags)}
                    </div>

                    {/* Title */}
                    <h3 className="cs-card-title">{item?.title}</h3>

                    {/* Author & Price */}
                    <div className="cs-card-meta">
                      <div className="cs-author">
                        <img
                          src={
                            item?.authorImage
                              ? item?.authorImage
                              : DEFAULT_USER_PROFILE_IMAGE
                          }
                          alt={item?.authorName}
                          className="cs-author-avatar"
                        />
                        <span className="cs-author-name">
                          {item?.authorName}
                        </span>
                      </div>
                      {item?.price > 0 && (
                        <span className="cs-price">
                          {item?.price} LKR
                        </span>
                      )}
                    </div>

                    {/* Instructor badge (admin/coordinator view) */}
                    {(() => {
                      const instructorName =
                        item?.instructorName ||
                        instructors.find(
                          (inst) => inst.id === item?.instructorId
                        )?.name;
                      if (instructorName) {
                        return (
                          <div className="cs-instructor-badge">
                            <UserOutlined />
                            <span className="cs-instructor-label">
                              Instructor:
                            </span>
                            <span className="cs-instructor-name">
                              {instructorName}
                            </span>
                          </div>
                        );
                      }
                      return null;
                    })()}
                  </div>
                </Link>

                {/* Actions */}
                <div className="cs-card-actions">
                  {isAdmin || isCoordinator || (isInstructor && item?.instructorId && userProfile?.id && String(item.instructorId) === String(userProfile.id)) ? (
                    <>
                      <Link
                        to={`/dashboard/cources/${item.id}`}
                        className="cs-action-btn cs-action-primary"
                      >
                        {item.type === 'book' ? "View Book" : "View Course"}
                      </Link>
                      {isAdmin && (
                        <button
                          className="cs-action-btn cs-action-assign"
                          onClick={() => {
                            setSelectedCourseId(item.id);
                            setSelectedCoordinatorId(
                              item.coordinatorId || undefined
                            );
                            setShowAssignModal(true);
                          }}
                        >
                          Assign
                        </button>
                      )}
                    </>
                  ) : (
                    <Link
                      to={`/dashboard/cources/${item.id}`}
                      className={`cs-action-btn cs-action-primary ${
                        userCources?.find(
                          (course) => course?.id === item?.id
                        )
                          ? ""
                          : "enroll"
                      }`}
                    >
                      {userCources?.find(
                        (course) => course?.id === item?.id
                      )
                        ? (item.type === 'book' ? "Read Book" : "Continue Learning")
                        : (item.type === 'book' ? (item.price === 0 ? "Get Book" : "Buy Book") : "Enroll Now")}
                    </Link>
                  )}

                  {item?.whatsappGroupLink && (
                    <a
                      href={item?.whatsappGroupLink}
                      target="_blank"
                      rel="noreferrer"
                      className="cs-action-btn cs-action-whatsapp"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <WhatsAppOutlined />
                    </a>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </Spin>

      {/* ─── Assign Modal ───────────────────────────────────── */}
      <Modal
        title="Assign Coordinator"
        open={showAssignModal}
        onOk={handleAssignCoordinator}
        confirmLoading={isAssigning}
        onCancel={() => setShowAssignModal(false)}
        okText="Assign"
        cancelText="Cancel"
        destroyOnClose
        className="cs-assign-modal"
      >
        <div style={{ padding: "16px 0" }}>
          <p style={{ marginBottom: "8px", color: "#6b7280" }}>
            Select a coordinator to assign to this course:
          </p>
          <Select
            placeholder="Select Coordinator"
            style={{ width: "100%" }}
            value={selectedCoordinatorId}
            onChange={(val) => setSelectedCoordinatorId(val)}
            allowClear
            showSearch
            optionFilterProp="children"
          >
            {coordinators.map((coord) => (
              <Select.Option key={coord.id} value={coord.id}>
                {coord.name} ({coord.email})
              </Select.Option>
            ))}
          </Select>
        </div>
      </Modal>

      <AddCource
        isOpen={isAddCourseOpen}
        setOpen={setIsAddCourseOpen}
        hadleGetCources={hadleGetCources}
        defaultType={activeTab === 'books' ? 'book' : 'course'}
      />
    </div>
  );
};
export default Cources;
